// extracted by mini-css-extract-plugin
export default {"fadeIn":"footer_fadeIn__TS9xv","logoSpread":"footer_logoSpread__1ejIP","logoItem":"footer_logoItem__Euymo"};